import { Platforms } from '@core/models';

export class SetPlatform {
  static readonly type = '[setPlatform] set Platform';
  static readonly desc = 'setting platform';
  constructor(public payload: Platforms) {}
}
